export function arrayToFileList(array) {
  const files = Array.from(array).map((item, index) => {
    if (item.file.documentId) {
      return null
    }

    const a = 'àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
    const b = 'aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
    const p = new RegExp(a.split('').join('|'), 'g')

    const newFileName = item.file.name.toString().toLowerCase().trim()
    .replace(p, c => b.charAt(a.indexOf(c)))
    .replace(/&/g, '_and_')
    .replace(/[\s\W-]+/g, '_')

    const newFile = new File([item.file], `${newFileName};fileKey=${item.file.fileKey}`, { type: item.file.type })

    return newFile
  }).filter(file => file !== null);;

  if (files.length === 0) {
    return []
  }

  const fileList = new DataTransfer();

  files.forEach(file => fileList.items.add(file));

  return fileList.files;
}
